import { PlaceSuggestion, PlaceSuggestionRequest, ApiResponse } from '../models/places.types';


class PlaceSuggestionService {
    private baseUrl: string;
    private apiKey: string;
    private abortController: AbortController | null = null;

    constructor() {
        this.baseUrl = '';
        this.apiKey = '';
    }

    /**
     * Fetch place suggestions based on search query
     */
    async getPlaceSuggestions(request: PlaceSuggestionRequest): Promise<PlaceSuggestion[]> {
        // Cancel any ongoing request
        this.cancelPendingRequest();

        // Create new abort controller for this request
        this.abortController = new AbortController();

        try {
            const params = new URLSearchParams({
                q: request.query,
                limit: (request.limit || 10).toString()
            });

            //      if (request.lat && request.lng) {
            //        params.append('lat', request.lat.toString());
            //        params.append('lng', request.lng.toString());
            //      }

            //      if (request.categories && request.categories.length > 0) {
            //        params.append('categories', request.categories.join(','));
            //      }

            const response = await fetch(`${this.baseUrl}/places/suggestion?${params.toString()}`, {
                method: 'GET',
//                headers: {
//                    'Content-Type': 'application/json',
//                    'Authorization': `Bearer ${this.apiKey}`
//                },
                signal: this.abortController.signal
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const apiResponse: PlaceSuggestion[] = await response.json();
            return apiResponse;

        } catch (error) {
            if (error instanceof Error && error.name === 'AbortError') {
                console.log('Request was cancelled');
                return [];
            }
            console.error('Failed to fetch place suggestions:', error);
            throw error;
        } finally {
            this.abortController = null;
        }
    }

	/**
	 * Cancel pending request
	 */
	cancelPendingRequest(): void {
	  if (this.abortController) {
	    this.abortController.abort();
	    this.abortController = null;
	  }
	}
}

export const placeSuggestionService = new PlaceSuggestionService();
